import routes from './routes'
import { Fetch } from '../fetch'
import { getTractorPayload } from '../../tools/dataParse'

class RecurringTractors {
  getRecurring ({ offset, body }) {
    return Fetch(
      'get',
      routes.recurringTractors + routes.getRecurringTractors({ offset, body })
    )
  }

  addRecurringTractor (tractor) {
    return Fetch(
      'post',
      routes.recurringTractors + routes.addRecurringTractor,
      getTractorPayload(tractor)
    )
  }

  updateRecurringTractor (tractor) {
    return Fetch(
      'put',
      routes.recurringTractors + routes.updateRecurringTractor,
      getTractorPayload(tractor)
    )
  }

  deleteRecurringTractor (id) {
    return Fetch(
      'delete',
      routes.recurringTractors + routes.deleteRecurringTractor(id)
    )
  }
}

export default new RecurringTractors()
